import { IsEmail, IsNotEmpty, IsString, MaxLength, MinLength, IsOptional, IsArray, IsBoolean } from "class-validator";
import { TeamAccessEditDTO } from '../team/team-access-edit.dto';

export class ContactEditDTO extends TeamAccessEditDTO {

    @IsNotEmpty()
    @IsString()
    @MaxLength(50)
    firstName: string;

    @IsNotEmpty()
    @IsString()
    @MaxLength(50)
    lastName: string;

    @IsOptional()
    @IsEmail()
    email: string;

    @IsOptional()
    @IsString()
    @MaxLength(50)
    image: string;

    @IsOptional()
    @IsString()
    @MaxLength(50)
    phone: string;

    @IsOptional()
    @IsString()
    @MaxLength(50)
    cellPhone: string;

    @IsOptional()
    @IsArray()
    @IsString({
        each: true
    })
    @MinLength(36, {
        each: true
    })
    @MaxLength(36, {
        each: true
    })
    accounts: Array<string>;

    @IsOptional()
    @IsArray()
    @IsString({
        each: true
    })
    @MinLength(36, {
        each: true
    })
    @MaxLength(36, {
        each: true
    })
    positions: Array<string>;

}
